var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoPrimary = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "logo-primary_svg__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: 0,
  y: 0,
  viewBox: "0 0 115 80",
  style: {
    enableBackground: "new 0 0 115 80"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".logo-primary_svg__st1{fill:#fff}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "logo-primary_svg__SVGID_1_",
  d: "M0 0h115v80H0z"
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-primary_svg__SVGID_00000143579977520112840120000013362997785439240127_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-primary_svg__SVGID_1_",
  style: {
    overflow: "visible"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#logo-primary_svg__SVGID_00000143579977520112840120000013362997785439240127_)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "logo-primary_svg__st1",
  d: "M3.3 28.1H0V13.3c0-4.8 3.9-8.8 8.7-8.8h14.7v3.4H8.7c-3 0-5.3 2.4-5.3 5.4l-.1 14.8zm20.1 48.5H8.7c-3 0-5.3-2.4-5.3-5.4V56.5H0v14.8C0 76.1 3.9 80 8.7 80h14.7v-3.4zM75 71.3V56.5h-3.3v14.8c0 3-2.4 5.4-5.3 5.4h-14V80h14c4.7 0 8.6-3.9 8.6-8.7zM50.6 4.2h4.6v2.3c1.1-1.4 2.5-2.6 4.8-2.6 2.1 0 3.7.9 4.6 2.6 1.4-1.7 3.1-2.6 5.3-2.6 3.4 0 5.5 2.1 5.5 6v10.7h-4.6v-9.1c0-2.2-1-3.3-2.7-3.3-1.7 0-2.8 1.1-2.8 3.3v9.1h-4.6v-9.1c0-2.2-1-3.3-2.7-3.3s-2.8 1.1-2.8 3.3v9.1h-4.6V4.2zM48.7 8.2v-4h-3.8V0h-4.6v4.2h-1.9v4h1.9v5.9c0 3.6 2.9 6.4 6.4 6.4h2v-4.6h-2c-1 0-1.8-.8-1.8-1.8v-6l3.8.1z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M115 32.7v13h-4.6V34.1c0-3.2-1.5-5-4.1-5-2.6 0-4.3 1.8-4.3 5.1v11.5h-4.6V34.1c0-3.2-1.5-4.9-4.1-4.9-2.6 0-4.2 1.8-4.3 4.8v11.7h-4.7v-3.1c-1.3 1.9-3.2 3.6-6.3 3.6-4.6 0-7.2-3.1-7.2-7.8V25.3h4.6v11.6c0 3.2 1.6 4.9 4.3 4.9 2.6 0 4.5-1.8 4.6-4.8V25.3H89v3.1c1.3-1.8 3.1-3.5 6.2-3.5 2.9 0 5 1.4 6 3.6 1.6-2.2 3.8-3.6 6.8-3.6 4.3 0 7 2.8 7 7.8zm-45.6-7.3c-3.3.1-5.5 2.1-6.7 5v-5H58v20.3h4.7v-7.3c0-5.3 2.7-7.9 6.7-8v-5zm-29.5 0h-8.4v-1c0-2.1.8-3.1 2.6-3.1.9 0 1.8.2 2.7.5v-3.9c-1.2-.4-2.5-.6-3.8-.5-1.9 0-3.4.5-4.5 1.6s-1.6 2.8-1.6 5v1.4H23v3.9h3.8v16.5h4.7V29.2H36c1-1.6 2.3-2.9 3.9-3.8zm17 10.2c0-6-4.8-10.8-10.7-10.8-5.9 0-10.7 4.8-10.7 10.8s4.8 10.8 10.7 10.8c5.9 0 10.7-4.8 10.7-10.8zm-10.8 6.1c-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1 6 2.7 6 6.1-2.6 6.1-6 6.1zm0-16.9c-5.9 0-10.7 4.8-10.7 10.8s4.8 10.8 10.7 10.8c5.9 0 10.7-4.8 10.7-10.8s-4.7-10.8-10.7-10.8zm0 16.9c-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1 6 2.7 6 6.1-2.6 6.1-6 6.1z",
  style: {
    fill: "#d91241"
  }
})));
export default SvgLogoPrimary;